import { useParams } from "react-router-dom";

export const useFunnelSourceListPageParams = () => {
  const { siteSlug = "", funnelSlug = "" } = useParams();

  return { siteSlug, funnelSlug };
};
